<template>
<div>
	<div class="title">保障计划及人员
		<span class="subtitle">可针对于不同工种选择不同方案，通过“继续添加工种”实现多工种保障方案，同一工种仅能选择一种保障方案</span>
	</div>
	<Form 
		:model="form" 
		:label-width="125" 
		ref="form"
		class="mt15">
		<FormItem 
			label="保障期限：" class="w800" prop="insuredPeriod"
			:rules="{required:true,message:'请选择保障期限',trigger:'change'}">
			<Select 
				v-model="form.insuredPeriod" 
				placeholder="请选择保障期限" 
				style="width: 300px"  
				@on-change="dateChange('insuredPeriod')">
				<Option value="12">1年</Option>
				<Option value="11">11个月</Option>
				<Option value="10">10个月</Option>
				<Option value="9">9个月</Option>
				<Option value="8">8个月</Option>
				<Option value="7">7个月</Option>
				<Option value="6">6个月</Option>
				<Option value="5">5个月</Option>
				<Option value="4">4个月</Option>
				<Option value="3">3个月</Option>
				<Option value="2">2个月</Option>
				<Option value="1">1个月</Option>
			</Select>
			<span v-if="this.info.productCode=='QYTTGZZRXPCNEW'" class="errorMsg">(4-5类，保障期限仅支持6~12个月)</span>
		</FormItem>
		<FormItem 
			label="保障起期：" class="w600"
			prop="effectiveDateStart"
			:rules="{required:true,message:'请选择保障起期',type:'date',trigger:'change'}">
			<DatePicker 
				v-model="form.effectiveDateStart" 
				type="date" 
				placeholder="请选择保障起期" 
				style="width: 300px" 
				@on-change="dateChange('effectiveDateStart')"
				:options="dateOptions">
			</DatePicker>
		</FormItem>
		<FormItem label="保障止期：" class="w600" required>
			{{form.effectiveDateEnd}}
		</FormItem>
		<FormItem label="附加险：" class="w800" required>
			<Checkbox v-model="form.subjoinAllDay"  @on-change="subjoinChange" :disabled="isReset==1">附加24小时伤残+医疗 基础方案价格*115%</Checkbox>
			<Checkbox v-model="form.subjoinOwnMedicine" @on-change="subjoinChange" disabled>附加自费药补偿 基础方案价格*120%</Checkbox>
			<Checkbox v-model="form.subjoinProportionAdj"  @on-change="subjoinChange" :disabled="isReset==1">附加伤残赔偿比例  基础方案价格*115%</Checkbox>
		</FormItem>
	</Form>
	<p v-if="fiveRisk" class="errorMsg">5类人员占比超过50%，保费上浮20%，上浮保费已标红色。</p>
	<Table 
		:columns="columns" 
		:data="list" 
		highlight-row
		disabled-hover>
		<template slot-scope="{ row, index }" slot="workTypeCode">
			<div>
				<div style="display: flex;">
					<Select style="width:80px;" v-model="list[index].isAerial" :disabled="isReset==1" @on-change="val=>aerialChange(val,index)" transfer>
						<Option value="1">高空</Option>
						<Option value="0">非高空</Option>
					</Select>
				<SelectJob :value="list[index].workTypeCode" :disabled="isReset==1" productCode="GSCGZZRX" @change="val=>jobChange(val,index)"/>
				</div>
				<span v-if="list[index].isAerial==1">风险分类：高空/6类</span>
				<span v-else>风险分类：{{list[index].jobCategory}}类</span>
				<!-- <span v-if="isRefuse==1">不符合</span>
				<span v-if="isRefuse==0">符合</span> -->
			</div>
		</template>
		<template slot-scope="{ row, index }" slot="insurancePlanCode">
			<div class="caseContainer">
				<Select v-model="list[index].insurancePlanCode" :disabled="isReset==1" placeholder="请选择保障方案" @on-change="caseChange(list[index])" transfer>
					<Option :value="item.planCode" v-for="(item, index) in caseList" :key="index">{{item.planName}}</Option>
				</Select>
				<p class="mt10">保费：{{list[index].initAmount}}元/人/年</p>
				<!-- <p class="mt10" v-else>保费：{{list[index].premium}}元/人/年</p> -->
			</div>
		</template>
		<template slot-scope="{ row, index }" slot="count">
	        <Input v-model="list[index].count" :maxlength="5" style="width:50px" :disabled="isReset==1" @change.native="countChange(list[index])"></Input> 人
		</template>
		<template slot-scope="{ row, index }" slot="amount">
			<span :style="{color:list[index].fiveRisk?'red':'#333'}">{{list[index].amount||0}}元</span>
		</template>
		<template slot-scope="{ row, index }" slot="manage">
			<!-- <a @click="addAmount(index)">加费</a> -->
			<a @click="del(index)" v-if="isReset!=1">删除</a>
		</template>
	</Table>
	<Table 
		:columns="totalColumns" 
		:data="totalData"
		:show-header="false"
		v-if="list.length>0"
		disabled-hover>
		<template slot-scope="{ row, index }" slot="count">
			{{row.count}}人
		</template>
		<template slot-scope="{ row, index }" slot="totalAmount">
			{{row.totalAmount}}元
		</template>
	</Table>
	<p class="errorMsg" v-if="errorMsg">{{errorMsg}}</p>
	<div class="download-btn mt15">
		<Button @click="add" :disabled="isReset==1">继续添加工种</Button>
		<UploadFile	
			style="display:inline-block"
			url="/pc/employerLiability/importEmployee"
			:show-upload-list="false"
			:data="{uuid:uuid,insuranceCompanyCode:'GUO_SHOU_CAI'}"
			btn-text="上传人员明细"
			@on-success="uploadSuccess" 
			:disabled="!canDownload&&isReset==1"/>
		<span class="downloadFile" v-if="canDownload">
			根据已选工种和方案人数，点击
			<a @click="download">下载</a>
		</span>
		<Button :type="personListValidate?'success':'error'" @click="openPersonList" v-show="personList.length>0">已上传人员信息</Button>
	</div>
	<Modal
		v-model="personListShow"
		:mask-closable="false"
		width="90%"
		title="已上传人员信息">
		<p class="errorMsg" v-if="!personListValidate">
			上传的人员信息存在错误，请查看校验结果，关闭后重新上传正确的人员明细。
		</p>
		<Table 
			:columns="personListColumns" 
			:data="personList"
			class="mt10"
			border
			:max-height="400"
			disabled-hover>
			<template slot-scope="{ row, index }" slot="msg">
				<span :style="{color:row.success?'green':'red'}">{{row.msg}}</span>
			</template>
		</Table>
		<template slot="footer">
			<Button type="primary" @click="personListShow=false">关闭</Button>
		</template>
	</Modal>
	<Modal
		v-model="addPreForm.show"
		:mask-closable="false"
		title="加费">
		<Form 
			:model="addPreForm.form" 
			:label-width="125" 
			ref="addPreForm"
			class="mt15">
			<FormItem label="当前价格：">{{addPreForm.form.premium}}元/人</FormItem>
			<FormItem 
				label="加费：" prop="addPre"
				:rules="{required:true,message:'请填写正确的金额，支持两位小数',trigger:'blur',pattern:rules.price}">
				<Input v-model="addPreForm.form.addPre" style="width:140px" ><span slot="append">元/人</span></Input>
			</FormItem>
			<FormItem label="加费后：">{{addPreForm.form.premium}}元/人</FormItem>
		</Form>	
		<template slot="footer">
			<Button type="primary" @click="addPreSubmit">确定</Button>
			<Button @click="addPreForm.show=false">取消</Button>
		</template>
	</Modal>
</div>
</template>
<script>
import UploadFile from '../common/UploadFile'
import SelectJob from '@/components/common/SelectJob'
export default {
	components:{ UploadFile,SelectJob },
	props:{
		info:Object,
	},
	data () {
		return {
			// 加费
			addPreForm:{
				show:false,
				form:{}
			},
			id:this.$route.params.id,
			isRenew:this.$route.query.renew||'',
			columns:[
                {title: '工种',slot: 'workTypeCode',width:300},
                {title: '保障方案',slot: 'insurancePlanCode',minWidth:200},
                {title: '人数',slot: 'count',width:120,align:'center'},
                {title: '保费小计',slot: 'amount',width:120},
                {title: '操作',slot: 'manage',width:70},
			],
			list:[],
			form:{
				subjoinAllDay:false,
				subjoinOwnMedicine:false,
				subjoinProportionAdj:false
			},
			dateOptions:{},
			caseList:[],
			totalColumns:[
				{title: '',key: 'title',minWidth:200,align:'right'},
                {title: '',slot: 'count',width:120},
                {title: '',slot: 'totalAmount',width:190},
			],
			totalData:[{
				title:'合计',
				count:'',
				totalAmount:'',
			}],
			canDownload:false,
			errorMsg:'',
			personListColumns:[
				{title: '校验结果',slot: 'msg',width:200},
                {title: '序号',type: 'index',width:70,align:'center'},
				{title: '工种',key: 'workType',width:150},
				{title: '保障方案',key: 'insurancePlan',minWidth:280},
                {title: '姓名',key: 'name',width:120},
				{title: '身份证号',key: 'certificateNumber',width:190},
			],
			personList:[],
			personListShow:false,
			uuid:'',
			isRefuse:'-1', //是否符合投保
			isReset:this.$route.query.reset||'', // 是否重新投保
			orderNo:this.$route.query.orderNo||'',
			checkOnce:true,
		}
	},
	computed:{
		/*校验人员明细*/
		personListValidate () {
			let flag = true;
			this.personList.map(item=>{
				if(!item.success){
					flag = false;
				}
			})
			return this.personList.length>0&&flag;
		},
		fiveRisk(){
			let fiveRisk=false
			this.list.forEach(item=>{
				if(item.fiveRisk)fiveRisk=true
			})
			return fiveRisk
		}
	},
	watch:{
		info (v) {
			this.setData();
			if(v.productCode){
				this.setStartTimeOption();
				this.getCaseList();
			}
		}
	},
	created(){
		this.setData();
		if(!this.isRenew){
			this.setStartTimeOption();
		}
		if(this.info.productCode)this.getCaseList();
	},
	methods:{
		async setStartTimeOption(limit){
			console.log('limit')
			console.log(limit)
			if(!this.isRenew){
				let startDate=await this.getEffectiveDateEnd(this.formatDate(new Date()),12,'start');
				this.dateOptions={
					disabledDate (date) {
						return date&&(date.valueOf()<Date.parse(startDate+' 00:00:00'))
					}
				}
			}else{
				this.dateOptions={
					disabledDate (date) {
						return date&&(date.valueOf()<Date.parse(limit+' 00:00:00'))
					}
				}
			}
		},
		setData() {
			this.form=this.info.recognize
			if(this.info.personList)this.personList=this.info.personList;
		},
		// 获取方案列表
		getCaseList () {
			this.$axios.post('/employerLiability/getSchemeList',{
				productCode:this.info.productCode
			}).then(res=>{
				this.caseList=res;
				if(this.id){
					this.getList();
				}else{
					this.add()
				}
			});
		},
		// 获取方案列表
		getList() {
			this.$axios.post('/employerLiability/getRecognizeeGroupBy.json',{
				value:this.id
			}).then(res=>{
				if(res.employerAmountVO){
					this.list=res.employerAmountVO;
					this.list.forEach(item=>{
						item.jobCategory=parseInt(item.riskTypeCode.split('_')[1])
						item.isAerial=item.isAerial?'1':'0'
						this.setItemPrice(item)
					})
					this.getPremium();
				}
			});

		},
		
		// 校验
		async val () {
			let flag = await this.$refs.form.validate();
			return new Promise((resolve,reject)=>{
				let hasHeighType=false
				this.list.forEach(item=>{
					if(item.jobCategory&&!isNaN(item.jobCategory)&&item.jobCategory>3){
						hasHeighType=true
					}
				})
				if (this.info.productCode=='QYTTGZZRXPCNEW'&&hasHeighType&&this.form.insuredPeriod<6) { //对外新产品校验不同
					this.toast('包含4类或5类人员时保障期限必须为6~12个月','error');
					resolve(false)
				} else if(this.info.productCode=='QYTTGZZRX'&&hasHeighType&&this.form.insuredPeriod!=12){
					this.toast('包含4类或5类人员时保障期限必须为1年','error');
					resolve(false)
				}else if(flag&&this.personListValidate){
					resolve({
						employerTotalAmountVO:{
							count:this.totalData[0].count,
							effectiveDateStart:this.formatDate(this.form.effectiveDateStart),
							effectiveDateEnd:this.form.effectiveDateEnd,
							insuredPeriod: this.form.insuredPeriod,
							totalAmount: this.totalData[0].totalAmount,
							uuid:this.uuid
						},
						importEmployeeVOS:this.personList,
						list:this.list
					})
				}else{
					this.toast('保障计划及人员校验失败','error');
					resolve(false)
				}
			})
		},
		/*日期变化后获取起保终保日期*/
		dateChange (type) {
			if(this.form.effectiveDateStart){
				this.getEffectiveDateEnd(this.formatDate(this.form.effectiveDateStart),this.form.insuredPeriod).then(res=>{
					this.$set(this.form,'effectiveDateEnd',res)
				})
			}
			// if(type=='insuredPeriod'){
				this.getPremium();
			// }
		},
		// 获取保障止期，父页面fillin也会用到
		getEffectiveDateEnd(effectiveDateStart,insuredPeriod,type='end'){
			return this.$axios.post('/employerLiability/getEffectiveDateEnd',{
				effectiveDateStart:effectiveDateStart,
				insuredPeriod:insuredPeriod,
				productCode:this.info.productCode
			}).then(res=>{
				if(type=='end'){
					return res.effectiveDateEnd
				}else{
					return res.effectiveDateStart
				}
			})
		},
		/*上传成功后获取数据*/
		uploadSuccess (res) {
			this.personList = res.data;
			this.openPersonList();
		},
		// 附加险选择
		subjoinChange() {
			this.list.forEach(item=>{
				item.subjoinAllDay=this.form.subjoinAllDay;
				item.subjoinOwnMedicine=this.form.subjoinOwnMedicine;
				item.subjoinProportionAdj=this.form.subjoinProportionAdj;
				this.setItemPrice(item)
			})
			this.getPremium();
		},
        charAtCode (code) {
            if (code) return (this.$route.query.productCode||this.info.productCode)+code.charAt(code.length - 1)
            else return ''
        },
		/*获取保费*/
		async getPremium () {
			let list=[]
			let listIndex=[]
			this.list.forEach((item,index)=>{
				if(item.workTypeCode&&item.insurancePlanCode&&item.count){
					listIndex.push(index);
					list.push({
						count: item.count,
						insurancePlanCode: this.charAtCode(item.insurancePlanCode),
						// insurancePlanCode: this.$route.query.productCode||this.info.productCode,
						insuredPeriod: this.form.insuredPeriod,
						productCode: this.$route.query.productCode||this.info.productCode,
						subjoinAllDay: item.subjoinAllDay,
						subjoinOwnMedicine: item.subjoinOwnMedicine,
						subjoinProportionAdj: item.subjoinProportionAdj,
						workTypeCode: item.workTypeCode,
						jobCategory:item.jobCategory,
						isAerial:item.isAerial
					})
				}
			})
			if(list.length==0){
				this.totalData=[{
					title:'合计',
					count:'',
					totalAmount:'',
				}]
				this.canDownload=false;
				this.errorMsg=''
				return
			}
			let obj = {
				employerAmountVO:list,
				productCode:this.$route.query.productCode||this.info.productCode,
				effectiveDateStart:this.formatDate(this.form.effectiveDateStart)
			}
			if (!obj.effectiveDateStart) return
			let res = await this.$axios.post('/employerLiability/calculationAmount.json',obj)
			this.uuid=res.uuid;
			if (this.$route.query.reset==1) {
				let checklist = await this.$axios.post('/employerLiability/checkEmployee.json',{uuid:this.uuid,insuranceCompanyCode:'GUO_SHOU_CAI',list:this.info.personList})
				this.info.personList = checklist
				this.personList = checklist
				this.$forceUpdate()
			}
			this.$emit('set-amount',res.totalAmount)
			res.employerAmountVO.forEach((item,index)=>{
				this.list[listIndex[index]].amount=item.amount;
				this.list[listIndex[index]].fiveRisk=item.fiveRisk;
				this.list[listIndex[index]].initAmount=item.initAmount;
				this.list.splice(listIndex[index],1,this.list[listIndex[index]]);
			})
			this.totalData=[{
				title:'合计',
				count:res.count,
				totalAmount:res.totalAmount,
			}]
			
			if(res.count<5){
				this.canDownload=false;
				this.errorMsg='！累计最低投保人数为5人，请继续添加工种'
			}else{
				this.canDownload=true;
				this.errorMsg=''
			}
			console.log(this.list)
		},
		// 添加工种
		add() {
			this.list.push({
				workTypeCode:'',
				insurancePlanCode:'',
				subjoinAllDay:this.form.subjoinAllDay,
				subjoinOwnMedicine:this.form.subjoinOwnMedicine,
				subjoinProportionAdj:this.form.subjoinProportionAdj,
				count:'',
				amount:''
			})
		},
		// 删除工种
		del(index) {
			this.confirm('确定删除？',()=>{
				this.list.splice(index,1)
				this.getPremium();
			})
		},
		// 加费
		addAmount (index) {
			let obj = this.jsonCopy(this.list[index])
			if (obj.amount=='') {
				this.alert('请选选择方案和人数，再进行加费操作')
			} else {
				this.addPreForm.index = index
				// obj.premium = 
				obj.addPremium = ''
				console.log(this.list[index])
				this.$refs.addPreForm.resetFields()
				this.addPreForm.form={}
				this.addPreForm.form = obj
				this.addPreForm.show=true
			}
		},
		// 加费提交
		async addPreSubmit () {
			let valid = await this.$refs.addPreForm.validate()
			if (valid) {
				// this.list[this.addPreForm.index] = this.jsonCopy(this.addPreForm.form)
				// console.log(this.list)
				// this.getPremium()
			}
		},
		// 选择工种
		jobChange(val,index) {
			console.log(val)
			if (!val) return
			this.isRefuse = val.isRefuse
			let row=this.list[index]
			let idx=this.list.findIndex(item=>{
				return item.workTypeCode==val.value
			})
			if(idx>-1){
				row.workTypeCode=val.value;// 要先赋值一下，才能清空
				this.$nextTick(()=>{
					row.workTypeCode='';
					this.list.splice(index,1,row)
				})
				this.alert('每个工种只能选择一种保障方案')
			}else{
				row.jobCategory=val.category;
				row.workTypeCode=val.value;
				this.list.splice(index,1,row)
				this.setItemPrice(row)
				if(row.insurancePlanCode&&row.workTypeCode&&row.count&&row.isAerial){
					this.getPremium();
				}
			}
		},
		// 选择方案
		caseChange(row) {
			this.setItemPrice(row)
			if(row.insurancePlanCode&&row.workTypeCode&&row.count&&row.isAerial){
				this.getPremium();
			}
		},
		// 输入人数
		countChange(row) {
			if(row.insurancePlanCode&&row.workTypeCode&&row.count&&row.isAerial){
				this.getPremium();
			}
		},
		// 选择高空，非高空
		aerialChange (val,index) {
			if(val&&this.list[index].insurancePlanCode&&this.list[index].workTypeCode&&this.list[index].count){
				this.getPremium();
			}
		},
		// 获取一行年保费
		setItemPrice(row) {
			if(row.jobCategory&&row.insurancePlanCode){
				let caseItem=this.caseList.find(item=>{
					return item.planCode==row.insurancePlanCode
				})
				let rate=1;
				if(this.form.subjoinAllDay)rate+=0.15;
				if(this.form.subjoinOwnMedicine)rate+=0.12;
				if(this.form.subjoinProportionAdj)rate+=0.15;
				let price=caseItem.prices.find(item=>{
					return item.priceCode=='RISK_'+row.jobCategory
				}).priceVal
				let premium=price*rate
				row.premium=Number(premium.toFixed(2))
				console.log(rate)
				console.log(price)
			}else{
				row.premium=''
			}
		},
		// 打开上传人员明细弹窗
		openPersonList() {
			this.personListShow=true
		},
		// 下载模板
		download() {
			this.exportToExcel('/employerLiability/exportExcelTemplate',{uuid:this.uuid})
		},
	}
}
</script>
<style scoped lang="less">
	.download-info{
		font-size: 14px;
		span{
			color:#FF9900;
			margin-left: 20px;
		}
	}
	.recognize{
		&-title{
			font-weight: bold;
		}
		&-total{
			font-size: 14px;
		}
	}
	.caseContainer{
		padding: 10px 0;
	}
	.subtitle{
		color: #FF9900;
		font-size: 14px;
		margin-left: 20px;
	}
	.downloadFile{
		font-size: 14px;
		margin-left: 20px;
		margin-right: 20px;
	}
	.errorMsg{
		font-size: 14px;
		color: red;
	}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/companyGroupEmployerGS/Recognize.vue